import { organization } from './api/entities';

export const actions = {
  resetOrganizationState: 'RESET_ORGANIZATION_STATE',
  createOrganization: 'CREATE_ORGANIZATION',
  updateOrganization: 'UPDATE_ORGANIZATION',
  listOrganization: 'LIST_ORGANIZATION',
  getOrganization: 'GET_ORGANIZATION',
};

export function resetOrganizationState() {
  return { type: actions.resetOrganizationState };
}

export function createOrganization(organizationObject) {
  return organization.create(actions.createOrganization, organizationObject, []);
}

export function updateOrganization(organizationId, organizationObject) {
  return organization.update(actions.updateOrganization, organizationId, organizationObject, []);
}

export function getOrganizations(query, sort) {
  return organization.list(actions.listOrganization, query, sort);
}

export function getOrganization(organizationId) {
  return organization.get(actions.getOrganization, organizationId, []);
}

const INITIAL_STATE = {
  organizations: [],
  organization: {},
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actions.resetOrganizationState:
      return {
        ...INITIAL_STATE,
      };
    case actions.createOrganization:
      return {
        ...state,
        organizations: action.body ? [...state.organizations, action.body] : state.organizations,
      };
    case actions.listOrganization:
      return {
        ...state,
        organizations: action.body ? action.body._items : state.organizations,
      };
    case actions.getOrganization:
      return {
        ...state,
        organization: action.body ? action.body : state.organization,
      };
    case actions.updateOrganization:
      return {
        ...state,
        id: action.body ? action.body : null,
      };
    default:
      return {
        ...state,
      };
  }
}
